import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: "root",
})
export class BaseService {
    postCodes = null;
    settings = null;
    parcelSizes = null;
    satchelSizes = null;

    constructor(private http: HttpClient,) { }

    changePassword(data: any) {
		return this.http.post(environment.apiUrl + `/api/changePassword`, data);
	}

	changeShippingLabelSize(data: any) {
		return this.http.post(environment.apiUrl + `/api/saveLabelSettings`, data);
	}

    getAddressList(params: any) {
		return this.http.get(environment.apiUrl + `/api/getAddresses`, {params});
	}

	addAddress(data: any) {
		return this.http.post(environment.apiUrl + `/api/saveAddress`, data);
	}

	deleteAddress(params: any){
		return this.http.delete(environment.apiUrl + `/api/deleteAddress`, {params});
	}

    public getPostCodeList(params: any, cache = true, isLoggedIn?:boolean): Observable<any> {
        if (!this.postCodes || !cache) {
            let action = '/api/postcodes';
            if(isLoggedIn){
                action = '/api/postcodesAndAddresses';
            }
     

            return this.http.get(environment.apiUrl + action, {params}).pipe(
                map((data: any) => {
                    console.log('getPostCodeList', data);
                    return this.postCodes = data;
                })
            );
        } else {
            return of(this.postCodes);
        }
    }

    public getSettings(): Observable<any> {
        if (!this.settings) {
            return this.http.get(environment.apiUrl + "/api/settings").pipe(
                map((data: any) => {
                    console.log('settings', data);
                    return this.settings = data;
                })
            );
        } else {
            return of(this.settings);
        }
    }

    public getPackageType(type: string): Observable<any> {
        if(type == 'parcel') {
            if (!this.parcelSizes) {
                return this.http.get(environment.apiUrl + "/api/packageTypes?type=parcel").pipe(
                    map((data: any) => {
                        console.log('parcelSizes', data);
                        return this.parcelSizes = data;
                    })
                );
            } else {
                return of(this.parcelSizes);
            }
        } else if(type == 'satchel') {
            if (!this.satchelSizes) {
                return this.http.get(environment.apiUrl + "/api/packageTypes?type=satchel").pipe(
                    map((data: any) => {
                        console.log('satchelSizes', data);
                        return this.satchelSizes = data;
                    })
                );
            } else {
                return of(this.satchelSizes);
            }
        } else {
            return new Observable<any>();
        }
    }

    getQuote(data: any, isLoggedIn:boolean = false): Observable<any> {
        let quoteUrl = isLoggedIn ? '/api/quoteByUser':'/api/quote';
		return this.http.post(environment.apiUrl + quoteUrl, data);
	}

    getQuoteByReference(referenceId: any): Observable<any> {
		return this.http.get(environment.apiUrl + `/api/getQuoteByReference?reference_no=${referenceId}`);
	}

    createBooking(data: any) {
		return this.http.post(environment.apiUrl + `/api/book`, data);
	}

    getOrderDetails(id: any) {
		return this.http.get(environment.apiUrl + `/api/getOrder?reference_id=${id}`)
	}

    printOrder(id: any) {
		return this.http.get(environment.apiUrl + `/api/printOrder/order_confirmation_${id}.pdf?id=${id}`, { responseType: 'blob' })
	}

    printOrderLabels(ids: any) {
		return this.http.get(environment.apiUrl + `/api/printLabels?ids=${ids}`, { responseType: 'blob' })
	}

    getTrackingDetails(trackingNo: any) {
		return this.http.get(environment.apiUrl + `/api/track?tracking_no=${trackingNo}`)
	}

    getCountries() {
		return this.http.get(environment.apiUrl + `/api/countries`)
	}

    getCategories(company:string='parcelplus') {
		return this.http.get(environment.apiUrl + `/api/categories/`+company)
	}

    getProducts(company:string,category: string, searchTerm: string) {
		return this.http.get(environment.apiUrl + `/api/products/`+company+`?category=${category}&q=${searchTerm}`)
	}

    getProduct(id: any) {
		return this.http.get(environment.apiUrl + `/api/products/${id}`)
	}

    getPaymentIntent(amount:number){
        amount = amount * 100;
        return this.http.get(environment.apiUrl+`/api/getPaymentIntent?amount=`+amount);
    }

    placeOrder(orderDetails:any){
        return this.http.post(environment.apiUrl+`/api/placeOrder`,orderDetails);
    }

    placeOrderOnAccount(orderDetails:any){
        return this.http.post(environment.apiUrl+`/api/placeOrderOnAccount`,orderDetails);
    }


}
